import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getSiteAbortApproval,
  acceptSiteStatusApproval,
  rejectAbortApproval,
} from 'services/redux/approvals/mrfApprovals/action';
// import PostponeInstallationApprovalList from './postponeInstallationApprovalsList';
import ViewPostponeInstallationDetails from './viewPostponeInstallationDetails';
import {
  viewInstallationDateChangeDetail,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  installationDateChangeDetail:state.siteListingReducer.installationDateChangeDetail

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      viewInstallationDateChangeDetail,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewPostponeInstallationDetails);
